module.exports = __webpack_public_path__ + "components/flag/static/square/lc-52b384935c72bcf34307e770971e8abd.svg";